import TopTicker from '@/pages/home/components/TopTicker';
import SiteNav from '@/pages/home/components/SiteNav';
import Hero from '@/pages/home/components/Hero';
import EntryBand from '@/pages/home/components/EntryBand';
import UpdateTimeline from '@/pages/home/components/UpdateTimeline';
import DownloadChannels from '@/pages/home/components/DownloadChannels';
import OnlineGuide from '@/pages/home/components/OnlineGuide';
import PackageSpec from '@/pages/home/components/PackageSpec';
import GuideCollection from '@/pages/home/components/GuideCollection';
import FaqList from '@/pages/home/components/FaqList';
import SiteFooter from '@/pages/home/components/SiteFooter';

export default function Home() {
  return (
    <div className="flex min-h-screen w-full flex-col bg-background-50">
      <TopTicker />
      <SiteNav />
      <main className="w-full">
        <Hero />
        <EntryBand />
        <UpdateTimeline />
        <DownloadChannels />
        <OnlineGuide />
        <PackageSpec />
        <GuideCollection />
        <FaqList />
      </main>
      <SiteFooter />
    </div>
  );
}